import { useEffect } from "react";
import { useAppDispatch } from "redux/hooks";
import { registerReferenceExperienceId } from "redux/slices/shed/shedSlice";
import useFranceRentalMapInit from "hooks/my-little-france/useFranceRentalMapInit";

/** Embed-only: France rental defaults + my-little-france experience. */
const useMyLittleFranceInit = () => {
  const dispatch = useAppDispatch();
  useFranceRentalMapInit();

  useEffect(() => {
    dispatch(registerReferenceExperienceId("my-little-france"));
  }, [dispatch]);
};

export default useMyLittleFranceInit;
